<template>
    <div class="mt-4">
        <h6 class="text-secondary text-capitalize">Próximos Agendamentos</h6>
    </div>
    <div class="d-flex mt-2 justify-content-center">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="card h-100">
                <div class="p-3" v-if="data && data.length">
                    <ul class="list-group">
                        <li v-for="scheduling in data" :key="scheduling.schedulingDate"
                            class="px-0 mb-2 border-0 list-group-item d-flex align-items-center">
                            <i class="fa fa-clock-o fa-2x me-3" aria-hidden="true"></i>
                            <div class="d-flex align-items-start flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ formatDate(scheduling.schedulingDate) }}</h6>
                                <p class="mb-0 text-xs">às {{ formatHour(scheduling.schedulingDate) }}</p>
                            </div>
                            <div class="ms-auto d-flex align-items-center">
                                <a class="mb-0 pe-3 ps-0 font-weight-bolder" style="color: #4F097B !important;">{{
                                    scheduling.status }}</a>
                                <a v-if="scheduling.status === 'Confirmado'" style="color: #f74d4d !important;"
                                    class="mb-0 btn btn-link pe-3 ps-0" @click="cancel(scheduling.schedulingId)">
                                    <i v-if="!loadingCancel" class="fa fa-trash" aria-hidden="true"></i>
                                    <i v-else class="fa fa-spinner fa-pulse fa-fw" aria-hidden="true"></i>
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="p-3" v-else>
                    Nenhum agendamento próximo encontrado
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import moment from 'moment';
import axios from 'axios';
import { useStore } from "vuex";
import { showToast } from "@/assets/js/toast.js";

const store = useStore();
const data = ref(null);
const loadingCancel = ref(false);
const contractData = computed(() => store.getters.getCurrentContract);
const error = ref(null);
const loading = ref(true);

const formatDate = (date) => {
    return moment(date).format('DD/MM/YYYY');
}

const formatHour = (date) => {
    return moment(date).format('HH:mm');
}

onMounted(() => {
    getClientSchedulings();
});

const getClientSchedulings = async () => {
    try {
        loading.value = true;
        const response = await axios.get(`/clients/scheduling/scheduling-salesforce/${contractData.value.contrato_id}`);
        data.value = response.data.message;
    } catch (err) {
        error.value = err.message;
    } finally {
        loading.value = false;
    }
}

const cancel = async (scheduleId) => {
    loadingCancel.value = true;
    try {
        await axios.put(`/clients/scheduling/salesforce/${scheduleId}`);
        getClientSchedulings();
        showToast('Agendamento cancelado com sucesso', 'success');
    } catch (err) {
        showToast('Erro ao cancelar agendamento, tente novamente', 'error');
        error.value = err.message;
    } finally {
        loadingCancel.value = false;
    }
}

</script>

<style>
.custom-card {
    background-color: #ffff;
    width: 100%;
    height: 164px;
}
</style>
